import { Modal } from './../../modal/Modal'
import { Typography } from '@mui/material'
import { DarkButton, SecondaryButton } from './../../custom-button/CustomButton'
import { ShopDomains, ShopFullDomains } from '@obeta/utils/lib/domains'
import { ShopFullLogoByDomain, ShopNameByDomain } from '@obeta/utils/lib/shopInfoByDomain'
import styles from './ChangeDomainPopup.module.scss'
import { TrendingFlatIcon } from '../../icons'

type ChangeDomainPopupProps = {
  isOpen: boolean
  domain: ShopDomains
  redirectDomain: ShopDomains
  onCloseChangeDomainPopup: () => void
  onSubmit: () => void
}

export const ChangeDomainPopup = ({
  isOpen,
  domain,
  redirectDomain,
  onCloseChangeDomainPopup,
  onSubmit,
}: ChangeDomainPopupProps) => {
  const CurrentDomainLogo = ShopFullLogoByDomain[domain]
  const RedirectedDomainLogo = ShopFullLogoByDomain[redirectDomain]

  return (
    <Modal open={isOpen} classNames={{ content: styles.modal }} onClose={onCloseChangeDomainPopup}>
      <div className={styles.root}>
        {CurrentDomainLogo && RedirectedDomainLogo && (
          <div className={styles.changeDomainLogoSection}>
            <CurrentDomainLogo className={styles.shopLogo} />
            <TrendingFlatIcon className={styles.switchAppSvg} />
            <RedirectedDomainLogo className={styles.shopLogo} />
          </div>
        )}
        <div className={styles.infoSection}>
          <Typography variant={'headline3Bold'} className={styles.title}>
            Weiterleitung
          </Typography>
          <div className={styles.infoTextWrapper}>
            <Typography variant={'boldText'}>
              Sie befinden sich auf der Website {ShopNameByDomain[domain]}.
            </Typography>
            <br />
            <Typography variant={'boldText'}>
              Ihre Anmeldeinformationen gehören zu der Website {ShopNameByDomain[redirectDomain]}{' '}
              {ShopFullDomains[redirectDomain] || ''}
            </Typography>
          </div>
        </div>
        <div className={styles.buttonsWrapper}>
          <div className={styles.buttonWrapper}>
            <SecondaryButton onClick={onCloseChangeDomainPopup} fullWidth={true}>
              Abbrechen
            </SecondaryButton>
          </div>
          <div className={styles.buttonWrapper}>
            <DarkButton onClick={onSubmit} fullWidth={true}>
              Jetzt weiterleiten
            </DarkButton>
          </div>
        </div>
      </div>
    </Modal>
  )
}
